import _ from "lodash";
import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import ParseTTC from "@/helpers/ParseTTC";
import {
  DELETE_FILTER,
  DELETE_FILTER_OPEN,
  DELETE_WIKI_OPEN,
  SAVE_FILTER_DRAGGED,
  SAVE_FILTER_ELEMENT,
  SAVE_FILTER_FOCUSED,
  SAVE_FILTER_FOCUSED_TYPE,
  SAVE_FILTER_OPEN,
  SAVE_FILTER_QUERY,
  SAVE_FILTERS_TO_EXPORT,
  SAVE_FILTERS,
  SAVE_FILTER_NAMES,
  SAVE_FILTERS_INDEX,
  SAVE_DUPLICATE_FILTERS,
  SAVE_IMPORTED_FILTERS,
  SAVE_LOADING_STEP,
  SAVE_SUBSET_FILTER,
  SAVE_TTC,
  SAVE_WIKI_OPEN,
  SAVE_WIKIS,
  TOGGLE_LOADING
} from "@/store/mutation-types";

export default {
  actions: {
    filterFocus: async ({ commit, dispatch, rootState }, payload) => {
      //console.log(payload);
      let enable = true;
      let filter = null;
      if (payload.filter === null) {
        enable = false;
      } else {
        if (payload.type === "Userfilter" || payload.type === "wiki") {
          //console.log(payload);
          filter = [{ _id: payload.filter._id }];
        } else {
          filter = payload.filter.rawquery;
        }
      }
      const message = `${enable ? "Applying" : "Disabling"} ${payload.type}`;
      commit(SAVE_LOADING_STEP, { loading_step: message });
      commit(TOGGLE_LOADING, { loading: true });

      return ApiRequest.explorePost(
        "filterfocus",
        {
          recentyear:
            rootState.setting.dataSettings.exploreConfig.recentyear || null,
          startyear:
            rootState.setting.dataSettings.exploreConfig.startyear || null,
          stopyear:
            rootState.setting.dataSettings.exploreConfig.stopyear || null,
          filt: enable ? filter : null,
          rettable: false,
          retagg: false,
          focus: false,
          convert_top: 0
        },
        GetHeaders.dataHeaders()
      ).then(res => {
        if (enable) {
          commit(SAVE_FILTER_FOCUSED, { filter: payload.filter });
          commit(SAVE_FILTER_FOCUSED_TYPE, { type: payload.type });
        } else {
          commit(SAVE_FILTER_FOCUSED, { filter: null });
          commit(SAVE_FILTER_FOCUSED_TYPE, { type: null });
        }
        // Update TTC
        if(rootState.layout.ttcState){
          const ttc = enable
            ? ParseTTC.filterFocus(rootState.ttc.ttc, res.data.data)
            : ParseTTC.clearFilterFocus(rootState.ttc.ttc);
          commit(SAVE_TTC, { ttc: ttc });
        }
        commit(TOGGLE_LOADING, { loading: false });
        //dispatch("loadFilters");
      });
    },
    loadFilters: async ({ commit, state }) => {
      let duplicates = [];
      let fNames = [];
      return ApiRequest.exploreGet("filter", GetHeaders.dataHeaders()).then(
        res => {
          _.each(res.data.categories, fc => {
            fc.type = "category";
            fc.open = state.filtersOpen.includes(fc._id);
            let emptyCategory = true;
            _.each(fc.children, fcc => {
              fcc.parent_id = fc._id;
              fcc.type = "subcategory";
              fcc.open = state.filtersOpen.includes(fcc._id);
              fcc.empty = fcc.children.length === 0;
              if (fcc.children.length > 0) {
                emptyCategory = false;
              }
              _.each(fcc.children, f => {
                f.parent_id = fcc._id;
                fNames.push(f.name);
                if("linkedfilter" in f){
                  duplicates.push(f.linkedfilter);
                }
              });
            });
            fc.empty = emptyCategory;
          });
          const sortedFilters = _.sortBy(res.data.categories, ['name']);
          sortedFilters.forEach(cat => {
            let sortedCat = _.sortBy(cat.children, ['name']);
            cat.children = sortedCat;
            cat.children.forEach(subcat => {
              let sortedsubcat = _.sortBy(subcat.children, ['name']);
              subcat.children = sortedsubcat;
            })
          });
          let filterIndex = [];
          _.forEach(sortedFilters, (category, n) => {
              _.forEach(category.children, (subcat) => {
                _.forEach(subcat.children, (filter) => {
                  let fIndex = _.map(filter.rawquery, '_id');
                  filterIndex = [...filterIndex, ...fIndex];
                });
              });
          });
          commit(SAVE_FILTER_NAMES, fNames);
          commit(SAVE_FILTERS, { filters: sortedFilters });
          commit(SAVE_DUPLICATE_FILTERS, { filters: duplicates });
          commit(SAVE_FILTERS_INDEX, { filters: filterIndex.filter(f => f && f.includes("TTC") && f !== "TTC_XXX") });
        }
      );
    },
    saveFilter: async ({ dispatch }, payload) => {
      const data = {
        filter: {},
        category: {},
        subcategory: {}
      };
      if (payload.filter.type === "filter") {
        data.filter = payload.filter;
        data.category = payload.category;
        data.subcategory = payload.subcategory;
      }

      if (payload.filter.type === "subcategory") {
        data.category = payload.category;
        data.subcategory = payload.filter;
      }

      if (payload.filter.type === "category") {
        data.category = payload.filter;
      }

      return ApiRequest.explorePost(
        "filter",
        data,
        GetHeaders.dataHeaders()
      ).then((res) => {
        dispatch("loadFilters");
        return res.data
      });
    },
    saveCategory: async ({ dispatch }, payload) => {
      const data = {
        filter: {},
        category: payload.category,
        subcategory: payload.subcategory
      };
      return ApiRequest.explorePost(
        "filter",
        data,
        GetHeaders.dataHeaders()
      ).then((res) => {
        dispatch("loadFilters");
        return res.data;
      });
    },
    saveSecondaryFilter: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "save_invalid_filters",
        payload,
        GetHeaders.dataHeaders()
      ).then((res) => {
        dispatch("loadFilters");
        return res.data
      });
    },
    updateSecondaryFilter: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "update_invalid_filters",
        payload,
        GetHeaders.dataHeaders()
      ).then((res) => {
        dispatch("loadFilters");
        return res.data
      });
    },
    uploadFilters: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "import_filters",
        payload,
        GetHeaders.dataHeaders()
      ).then((imports) => {
        dispatch("loadFilters");
        return imports.data
      });
    },
    updateImportedFilters: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "update_imported_filter",
        payload,
        GetHeaders.dataHeaders()
      ).then((imports) => {
        dispatch("loadFilters");
        return imports.data
      });
    },
    saveBulkImportedFilters: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "save_import_filters",
        payload,
        GetHeaders.dataHeaders()
      ).then(() => {
        dispatch("loadFilters");
        return
      });
    },
    saveImpFilters: ({ commit }, payload) => {
      let sortedFilters = _.sortBy(payload.filters.categories, ['name']);
      sortedFilters.forEach(cat => {
        let sortedCat = _.sortBy(cat.children, ['name']);
        cat.children = sortedCat;
        cat.children.forEach(subcat => {
          let sortedsubcat = _.sortBy(subcat.children, ['name']);
          subcat.children = sortedsubcat;
        })
      });
      commit(SAVE_IMPORTED_FILTERS, { filters: sortedFilters });
    },
    addFiltersToExport: ({ commit }, payload) => {
      commit(SAVE_FILTERS_TO_EXPORT, payload)
    },
    toggleFilterOpen: ({ commit }, payload) => {
      if (payload.filter.open) {
        commit(SAVE_FILTER_OPEN, { filterId: payload.filter._id });
        //dispatch("loadFilters");
        return;
      }
      commit(DELETE_FILTER_OPEN, { filterId: payload.filter._id });
      //dispatch("loadFilters");
    },
    toggleWikiOpen: ({ commit }, payload) => {
      if (payload.wiki.open) {
        //dispatch("loadFilters");
        commit(SAVE_WIKI_OPEN, { wikiId: payload.wiki._id });
        return;
      }
      //dispatch("loadFilters");
      commit(DELETE_WIKI_OPEN, { wikiId: payload.wiki._id });
    },
    deleteFilter: async ({ dispatch }, payload) => {
      if(payload.filter._id.includes("invalid")){
        return ApiRequest.explorePost(
          "delete_invalid_filter",
          { filter_id: payload.filter._id },
          GetHeaders.dataHeaders()
        ).then(() => {
          dispatch("loadFilters");
        });
      }
      else{
        return ApiRequest.exploreDelete(
          "filter/" + payload.filter._id,
          GetHeaders.dataHeaders()
        ).then(() => {
          dispatch("loadFilters");
        });
      }
    },
    deleteBulkFilter: async ({ dispatch }, payload) => {
      return ApiRequest.explorePost(
        "delete_multiple_filters",
        payload,
        GetHeaders.dataHeaders()
      ).then(() => {
        dispatch("loadFilters");
      });
    },
    saveFilterQuery: ({ commit }, payload) => {
      commit(SAVE_FILTER_QUERY, { query: payload.query });
    },
    searchFilters: ({ state }, payload) => {
      let filteredFilters = [];
      _.each(state.filters, cat => {
        _.each(cat.children, subcat => {
          let filtered = subcat.children.filter(f =>
            f.name.includes(payload.query) && !f.name.includes("_del") && !f._id.includes("invalid_filter_")
          );
          filteredFilters.push(...filtered);
        });
      });
      return filteredFilters;
    },
    saveSubsetFilter: ({ commit }, payload) => {
      commit(SAVE_SUBSET_FILTER, { data: payload });
    },
    saveFilterElement: ({ commit }, payload) => {
      commit(SAVE_FILTER_ELEMENT, { data: payload });
    },
    resetFilter: ({ commit }) => {
      commit(SAVE_FILTER_FOCUSED, { filter: null });
      commit(SAVE_FILTER_FOCUSED_TYPE, { type: null });
    },
    setFilterDragged: ({ commit }, payload) => {
      commit(SAVE_FILTER_DRAGGED, { filter: payload });
    }
  },
  getters: {},
  mutations: {
    [SAVE_FILTERS](state, payload) {
      state.filters = payload.filters;
    },
    [SAVE_FILTER_NAMES](state, payload) {
      state.filterNames = payload;
    },
    [SAVE_DUPLICATE_FILTERS](state, payload) {
      state.filterDuplicates = payload.filters;
    },
    [SAVE_IMPORTED_FILTERS](state, payload) {
      state.importedFilters = payload.filters;
    },
    [SAVE_FILTER_OPEN](state, payload) {
      state.filtersOpen.push(payload.filterId);
      //const deduplicated = new Set(state.filtersOpen);
      //console.log(state.api.apiId)
      //localStorage.setItem(state.api.apiId + "_open_filters", [
      //  ...deduplicated
      //]);
    },
    [SAVE_FILTER_FOCUSED](state, payload) {
      state.filterFocused = payload.filter;
    },
    [SAVE_FILTER_FOCUSED_TYPE](state, payload) {
      state.filterFocusedType = payload.type;
    },
    [SAVE_FILTER_QUERY](state, payload) {
      state.filterQuery = payload.query;
    },
    [SAVE_FILTERS_INDEX](state, payload) {
      state.filterIndex = payload.filters;
    },
    [DELETE_FILTER_OPEN](state, payload) {
      const deduplicated = new Set(state.filtersOpen);
      deduplicated.delete(payload.filterId);
      //console.log(state.api.apiId)
      //localStorage.setItem(state.api.apiId + "_open_filters", [
      //  ...deduplicated
      //]);
      state.filtersOpen = [...deduplicated];
    },
    [DELETE_FILTER](state, payload) {
      _.each(state.filters, filterCategory => {
        const i = filterCategory.filters.findIndex(v => v.id === payload.id);
        if (i >= 0) {
          filterCategory.filters.splice(i, 1);
        }
      });
    },
    [SAVE_SUBSET_FILTER](state, payload) {
      state.subsetFilter = [];
      let index = _.findIndex(state.visualSelections, [ 'visual', payload.data[0]]);
      if(payload.data[0] === null){
        state.visualSelections = [];
      }
      else if(index > -1){
        if(payload.data[1] && payload.data[1].length > 0 ){
          state.visualSelections[index].selections = payload.data[1];
        }
        else{
          state.visualSelections.splice(index, 1);
        }
      }
      else{
        state.visualSelections.push({ visual: payload.data[0], selections: payload.data[1] })
      }
      state.visualSelections.forEach((s, n) => {
        if(s.selections && s.selections.length > 0){
          state.subsetFilter.push(s.selections, "AND");
        }
        if(state.visualSelections.length === n+1){
          state.subsetFilter.pop();
        }
      })
    },
    [SAVE_FILTER_ELEMENT](state, payload) {
      state.filterElement = payload.data;
    },
    [SAVE_WIKIS](state, payload) {
      state.wikis = payload.wikis;
    },
    [SAVE_WIKI_OPEN](state, payload) {
      state.wikisOpen.push(payload.wikiId);
      localStorage.setItem(state.api.apiId + "_open_wikis", state.wikisOpen);
    },
    [DELETE_WIKI_OPEN](state, payload) {
      const i = state.wikisOpen.findIndex(v => v.id === payload.wikiId);
      state.wikisOpen.splice(i, 1);
      localStorage.setItem(state.api.apiId + "_open_wikis", state.wikisOpen);
    },
    [SAVE_FILTER_DRAGGED](state, payload) {
      state.filterDragged = payload.filter;
    },
    [SAVE_FILTERS_TO_EXPORT](state, payload) {
      if(Array.isArray(payload)){
        state.filtersToExport = payload;
      }
      else{
        if(state.filtersToExport.includes(payload)){
          state.filtersToExport.splice(state.filtersToExport.indexOf(payload), 1)
        }
        else{
          state.filtersToExport.push(payload)
        }
      }
    }
  },
  state: {
    filterElement: null,
    filterFocused: null,
    filterDragged: null,
    filterFocusedType: null,
    filterQuery: [],
    filters: [],
    filterNames: [],
    filterIndex: [],
    filterDuplicates: [],
    importedFilters: [],
    filtersOpen: [],
    filtersToExport: [],
    visualSelections: [],
    subsetFilter: [],
    wikisOpen: [],
    wikis: []
  }
};
